<template>
    <div class="wrapper">

         <div class="info">
            <span class="label">{{$t('withdrawalway')}}：</span>
            <div class="r">
                <el-radio v-model="form.type" @change="radioChange" :label="1">
                  <!-- 银行卡 -->
                  {{$t('bankCard')}}
                </el-radio>
                <el-radio v-model="form.type" @change="radioChange" :label="2">
                  <!-- 支付宝 -->
                  {{$t('alipay2')}}
                </el-radio>
            </div>
        </div>
        <template v-if="form.type == 1">
           <div class="info">
                <span class="label">{{$t('account')}}</span>
                <div class="r">
                  <el-select v-model="form.cardId" :placeholder="$t('pleaseSelect')">
                    <el-option
                      v-for="item in bankArr"
                      :key="item.card_number"
                      :label="item.card_number"
                      :value="item.id">
                    </el-option>
                  </el-select>
                </div>
            </div>
        </template>
        <template v-if="form.type == 2">
           <div class="info">
                <span class="label">{{$t('account')}}</span>
                <div class="r">
                  <el-select v-model="form.cardId" :placeholder="$t('pleaseSelect')">
                    <el-option
                      v-for="item in aliArr"
                      :key="item.account_number"
                      :label="item.account_number"
                      :value="item.id">
                    </el-option>
                  </el-select>
                </div>
            </div>
        </template>      

        <div class="info">
            <span class="label">{{$t('money')}}：</span>
            <div class="r">
                <el-input type="text" style="width: 217px" class="input" v-model="form.money"></el-input>
            </div>
            <div class="max-money">{{$t('withdrawableCash')}} <span>{{$t('currencySymbol')}}{{userInfo.balance || 0}}</span></div>
        </div> 


        <div class="save" @click="submit">{{$t('save')}}</div>

        <div class="table">
        <el-table
        :empty-text="$t('noData')"
        :data="tableData"
        style="width: 100%">
        <el-table-column
            width="180"
            prop="card_number"
            :label="$t('cardNum')">
        </el-table-column>
        
        <el-table-column
            prop="money"
            :label="$t('money')"
            >
        </el-table-column>

         <el-table-column
            prop="ctime"
            :label="$t('time')"
            >
        </el-table-column>

        <el-table-column
            prop="type"
            :label="$t('state')"
           >
        </el-table-column>

        </el-table>


        
      </div>

      <Pagination
        v-if="tableData.length>0"
        :totalPage="totalPage"
        :limit="10"
        @changePage="handleCurrentChange"
      ></Pagination>
        
    </div>
</template>

<script>
import Pagination from "@/components/common/Pagination.vue";

export default {
  components: {
    Pagination
  },
    data() {
        return {
            aliArr: [], // 支付宝账号列表
            bankArr: [], // 银行卡账号列表
            form: {
              cardId: '', // 
              money: '', // 金额
              type: 1 // 1 银行卡， 2 支付宝
            },
            userInfo: {}, // 用户信息
            tableData: [], // 提现数据
            page: 1,
            limit: 10,
            totalPage: 0
        }
    },
    created(){
      this.getUser()
      this.cashAction()
      this.aliList()
      
      this.bankList()
    },
    methods: {
      radioChange() {
        this.form.cardId = ''
      },
      // 获取用户信息
      getUser() {
        this.$api.userInfo().then(res => {
            if(res.status) {
                this.userInfo = res.data
            }
        })
      },
      // 提现操作
      submit() {
        this.$api.userToCash(this.form).then(res =>{
          
          if(res.status) {
            this.$message({
              message: res.msg,
              type: 'success'
            })
            this.cashAction()
            this.getUser()
          } else{
            this.$message({
              message: res.msg,
              type: 'warning'
            })
          }
        })
      },
      handleCurrentChange() {
        this.page += 1
        this.cashAction()
      },
      // 提现记录
      cashAction() {
        this.$api.cashList({
          page: this.page,
          limit: this.limit
        }).then(res => {
          if(res.status) {
            this.tableData = res.data
             this.totalPage = Math.ceil(res.total / this.limit) 
          }
        })
      },
      // 支付宝账号列表
      aliList() {
        this.$api.getalipaylist().then(res => {
            console.log('res', res)
          if(res.status) {
            this.aliArr = res.data
          }
        })
      },
      // 银行卡账号列表
      bankList() {
        this.$api.getBankCardList().then(res =>{
          if(res.status) {
            this.bankArr = res.data
          }
        })
      }
      
    }
}
</script>

<style lang="scss" scoped>
@import "~@/assets/css/variable.scss";
.input {
  width: 200px;
}
.max-money {
  margin-left: 20px;
  color: #333;
  span {
    color: #EA4B49;
  }
}
.wrapper {
  .save {
    width: 120px;
    height: 30px;
    text-align: center;
    line-height: 30px;
    background: $theme-color;
    color: #fff;
    margin-left: 108px;
    margin-top: 30px;
    cursor: pointer;
  }
  .info {
    display: flex;
    align-items: center;
    margin-bottom: 30px;
    &.head {
      align-items: flex-start;
      .label {
        padding-top: 10px;
      }
    }
    .label {
      display: inline-block;
      width: 90px;
      margin-right: 20px;
    }
    .r {
      .user-head {
        width: 80px;
        height: 80px;
        border-radius: 50%;
        position: relative;
        &:hover {
          .change {
            display: block;
          }
        }
        .input-file {
          position: absolute;
          width: 100%;
          height: 100%;
          top: 0;
          left: 0;
          opacity: 0;
          cursor: pointer;
          z-index: 99;
        }
        .change {
          display: none;
          position: absolute;
          top: 50%;
          left: 50%;
          width: 70px;
          height: 18px;
          margin-left: -35px;
          line-height: 18px;
          text-align: center;
          margin-top: -8px;
          background: #757575;
          color: #fff;
          cursor: pointer;
        }
        img {
          display: block;
          width: 100%;
          height: 100%;
          border-radius: 50%;
        }
      }
      .info-input {
        width: 160px;
        height: 24px;
        line-height: 24px;
        border: 1px solid $border;
        padding-left: 12px;
      }
    }
  }
}

</style>